import { ActionIcon, CopyButton, Group, type GroupProps } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

export interface ErrorTitleProps extends GroupProps {
    error: string;
}

export default function ErrorTitle({ error, children, ...props }: ErrorTitleProps) {
    return (
        <Group gap="xs" {...props}>
            <CopyButton value={error}>
                {({ copy, copied }) => (
                    <ActionIcon size="sm" onClick={copy}>
                        {copied ? <IconCheck /> : <IconCopy />}
                    </ActionIcon>
                )}
            </CopyButton>

            <h2
                css={{
                    margin: 0,
                    fontSize: 'var(--mantine-font-size-md)',
                    whiteSpace: 'pre-wrap',
                }}
            >
                {children}
            </h2>
        </Group>
    );
}
